import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
//Antd
import { Button, Col, Divider, Row, Tooltip, Upload } from "antd";
import { SearchOutlined, EditOutlined } from "@ant-design/icons";
import { FileOutlined } from "@ant-design/icons";
import { CalendarOutlined, ClockCircleOutlined } from "@ant-design/icons";
//Ducks
import * as reqDuck from "../../../../redux/aspirante/reqAcademicoDuck";
import { getUrlUpload } from "../../../../redux/aspirante/catalogoDucks";
//Utils
import * as utils from "../../../../utils";
import * as expDuck from "../../../../redux/aspirante/expDigitalDucks";

/**
 * Componente que muestra los archivos con su nombre y opciones de descarga y modificación
 * @param {object} item: Del archivo académico capturado por el aspirante
 */
export const DescripcionArchivo = ({ item }) => {
  const dispatch = useDispatch();
  const [urlUpload, setUrlUpload] = useState("");
  //State
  const { nivelEstudios } = useSelector((state) => state.catalogos);
  const { correo } = useSelector((state) => state.usuarioLogin);
  const { bloquearPorFecha } = useSelector((state) => state.bloqueoEstatus);
  const { estatusPostulacion } = useSelector(
    (state) => state.bloqueoEstatus.concurso
  );

  //--------------------- Se obtiene la url generica para la carga de archivos -----------------
  useEffect(() => {
    //Se obtiene la url para simular la correcta carga del archivo
    dispatch(getUrlUpload()).then((data) => {
      setUrlUpload(data);
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  //--------------------------------------------------------------------------------------------

  /**
   * Función que recupera el nombre del nivel de estudios a partir del id.
   * @param {number} id del nivel de studios.
   * @returns {string} Nombre del nivel de estudios.
   */
  const getText = (idItem) =>
    nivelEstudios.find(({ id }) => id === +idItem)?.nombre;

  /**
   * Función que permite la subida del archivo
   * @param {File} info
   * @param {object} oldFile
   */
  const handleChange = (info, oldFile) => {
    const { status } = info.file;
    if (status !== "uploading") {
      dispatch(reqDuck.setLoading(true));
    }
    if (status === "done") {
      //Se agrega el archivo y el objeto a modificar
      agregarDocumento(info.file, oldFile);
      dispatch(reqDuck.setLoading(false));
    } else if (status === "error") {
      const mensaje = "Al adjuntar el archivo, favor de volver a intentar.";
      utils.openNotification("error", utils.ERROR, mensaje);
      dispatch(reqDuck.setLoading(false));
    }
  };

  /**
   * Función que permite guardar el archivo con el tipo de documento seleccionado
   * @param {File} file
   * @param {Object} oldFile
   */
  const agregarDocumento = (file, oldFile) => {
    const { rutaArchivo, idAspirante, idEscolaridad, idArchivo } = oldFile;
    //Se construye el object con la información del documento
    const json = {
      id: idAspirante,
      idEscolaridad,
      usuario: correo,
      archivo: file,
      idArchivo,
      rutaArchivo,
    };
    //Se Guarda el documento en la lista del state
    dispatch(reqDuck.setDocumentoUpd(json));
  };

  /**
   * función para mostrar el modal de los detalles del documento
   * @param {object} documento
   */
  const openModalDetalle = (documento) => {
    dispatch(expDuck.setModalActiveDetalle(true, documento));
  };

  /**
   * Función que permite mostrar el modal visualizando el documento adjuntado
   * @param {object} documento
   */
  const openPDF = (document) => {
    const { rutaArchivo } = document;
    dispatch(reqDuck.setLoading(true));
    // Se envía la ruta del archivo
    dispatch(reqDuck.download(rutaArchivo))
      .then(({ data }) => {
        let fileURL = window.URL.createObjectURL(data);
        window.open(fileURL);
        dispatch(reqDuck.setLoading(false));
      })
      .catch((error) => {
        utils.openNotification("warning", "Atención", utils.ERROR_ARCHIVO);
        dispatch(reqDuck.setLoading(false));
      });
  };

  return (
    <>
      <Row style={{ marginTop: -10 }}>
        <Col xxl={1} xl={1} lg={1} md={1} sm={1} xs={24}>
          <Divider type="vertical" className="card-divider" />
        </Col>
        <Col xxl={16} xl={16} lg={16} md={16} sm={16} xs={24}>
          <h1 className="card-documento">{getText(item.idNivEstudio)}</h1>
        </Col>
        <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={24}>
          <Row justify="end">
            <Tooltip title="Visualizar">
              <Button
                id="bntCircle"
                shape="circle"
                icon={<SearchOutlined />}
                style={{ marginTop: 0, marginRight: "5px" }}
                onClick={() => openPDF(item)}
              />
            </Tooltip>
            {!bloquearPorFecha && !estatusPostulacion && (
              <Tooltip title="Actualizar">
                <Upload
                  {...utils.files}
                  accept=".pdf,.PDF"
                  showUploadList={false}
                  onChange={(e) => {
                    handleChange(e, item);
                  }}
                  action={urlUpload}
                >
                  <Button
                    id="bntCircle"
                    shape="circle"
                    icon={<EditOutlined />}
                    style={{ marginTop: 0, marginRight: "5px" }}
                  />
                </Upload>
              </Tooltip>
            )}
          </Row>
        </Col>
      </Row>

      {item?.justificacion && (
        <Row justify="end" style={{ marginTop: 10 }}>
          <span
            style={{ textDecoration: "underline", fontWeight: 600 }}
            onClick={() => {
              openModalDetalle(item);
            }}
          >
            Ver detalle...
          </span>
        </Row>
      )}

      <Row className="card-documento-fecha">
        <Col xxl={14} xl={14} lg={14} md={14} sm={14} xs={24}>
          <div className="card-fecha-hora">
            <>
              <FileOutlined /> {item.nombreArchivoOriginal}
            </>
          </div>
        </Col>
        <Col xxl={10} xl={10} lg={10} md={10} sm={10} xs={24}>
          <CalendarOutlined /> {item.fecha} <Divider type="vertical" />{" "}
          <ClockCircleOutlined /> {item.hora}
        </Col>
      </Row>
    </>
  );
};
